import type { ReactElement } from "react";
import { CmtsComplaintSubcategoryContainer } from "../../core/containers/domain/masterdataRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  void props.runtime;
  return <CmtsComplaintSubcategoryContainer />;
}

export default Component;
